<script>
  import PageHero from '$lib/page/Hero.svelte';
  import Quote from '$lib/Quote.svelte';
  import EntryContent from '$lib/EntryContent.svelte';
  import CompanyResources from '$lib/company/resources/Index.svelte';
  import Cta from '$lib/company/CallToAction.svelte';
  import SectionWysiwyg from '$lib/company/SectionWysiwyg.svelte';
  import ImageSlider from '$lib/company/ImageSlider.svelte';
  import Seo from '$lib/Seo.svelte';
  import Faq from '$lib/faq/Index.svelte';

  export let hero;
  export let blocks = [];
  export let faq;
  export let seo;

  let blockMapping = {
    quote: Quote,
    images: ImageSlider,
    resources: CompanyResources,
    wysiwyg: SectionWysiwyg,
    entryContent: EntryContent,
    cta: Cta,
  };
</script>

<div class="page-story">
  <PageHero {hero} />
  {#each blocks as block}
    <svelte:component this={blockMapping[block.type]} {...block.data} />
  {/each}
  {#if seo}
    <Seo {seo} />
  {/if}
  {#if faq}
    <Faq {faq} />
  {/if}
</div>

<style lang="scss">
  .page-story {
    :global .inner-container.inner-container--tight {
      @include resp-max('s') {
        border-radius: unset;
        padding: 0 0 6rem;
        box-shadow: unset;
        margin-top: 0;
      }
    }

    :global .cta {
      @include resp-max('s') {
        border-top: 1px solid $light-border;
      }
    }
  }
</style>
